import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { system } from '@config/system';
import { css, Global } from '@emotion/react';
import breakpoints from './foundations/breakpoints';
import { getParentSelector } from './helpers';
export const CSSReset = ({ disableCssTitleReset = false, scope, }) => (_jsxs(_Fragment, { children: [_jsx(Global, { styles: css `
      ${getParentSelector(scope)} {
        box-sizing: border-box;
        color: var(--booking-engine-colors-neutral-900);
        font-size: var(--booking-engine-fontSizes-lg);
        line-height: var(--booking-engine-lineHeights-base);
        -webkit-text-size-adjust: 100%;
        font-family: var(--booking-engine-fonts-body), system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
        position: relative;
        margin: 0;
        font-feature-settings: "kern";

        --cb-text--font-family: var(--booking-engine-fonts-body);
        --cb-title-text--font-family: var(--booking-engine-fonts-heading);
      }
        
      ${getParentSelector(scope)} *,
      ${getParentSelector(scope)} *::after,
      ${getParentSelector(scope)} *::before {
        border-color: var(--booking-engine-colors-chakra-border-color);
        border-style: solid;
        border-width: 0;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      ${getParentSelector(scope)} :is(*) {
        -webkit-tap-highlight-color: transparent;
      }

      ${getParentSelector(scope)} main {
        display: block;
      }

      ${getParentSelector(scope)} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${getParentSelector(scope)} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${getParentSelector(scope)} a {
        background-color: transparent;
        color: inherit;
        font-size: inherit;
        text-decoration: underline;
      }

      ${getParentSelector(scope)} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${getParentSelector(scope)} :where(b, strong) {
        font-weight: bold;
      }

      ${getParentSelector(scope)} small {
        font-size: 80%;
      }

      ${getParentSelector(scope)} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${getParentSelector(scope)} sub {
        bottom: -0.25em;
      }

      ${getParentSelector(scope)} sup {
        top: -0.5em;
      }

      $${getParentSelector(scope)} img {
        border-style: none;
      }

      ${getParentSelector(scope)} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
        text-align: left;
      }

      ${getParentSelector(scope)} :where(button, input) {
        overflow: visible;
      }

      ${getParentSelector(scope)} :where(button, select) {
        text-transform: none;
      }

      ${getParentSelector(scope)} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${getParentSelector(scope)} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${getParentSelector(scope)} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${getParentSelector(scope)} progress {
        vertical-align: baseline;
      }

      ${getParentSelector(scope)} textarea {
        overflow: auto;
      }

      ${getParentSelector(scope)} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${getParentSelector(scope)} input[type="number"]::-webkit-inner-spin-button,
      ${getParentSelector(scope)} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${getParentSelector(scope)} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${getParentSelector(scope)} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${getParentSelector(scope)} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${getParentSelector(scope)} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${getParentSelector(scope)} details {
        display: block;
      }

      ${getParentSelector(scope)} summary {
        display: list-item;
      }

      ${getParentSelector(scope)} template {
        display: none;
      }

      ${getParentSelector(scope)} div {
        text-align: left;
      }

      ${getParentSelector(scope)} [hidden] {
        display: none !important;
      }

      ${getParentSelector(scope)} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        color: inherit;
        line-height: inherit;
        margin: 0;
      }

      ${getParentSelector(scope)} :where(p) {
        font-size: var(--booking-engine-fontSizes-lg);
      }

      ${getParentSelector(scope)} button {
        background: transparent;
        padding: 0;
      }

      ${getParentSelector(scope)} fieldset {
        margin: 0;
        padding: 0;
      }

      ${getParentSelector(scope)} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${getParentSelector(scope)} textarea {
        resize: vertical;
      }

      ${getParentSelector(scope)} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${getParentSelector(scope)} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${getParentSelector(scope)} table {
        border-collapse: collapse;
      }

      ${getParentSelector(scope)} :is(h1, h2, h3, h4, h5, h6) {
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
        text-transform: initial;
      }

      ${getParentSelector(scope)} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${getParentSelector(scope)} :where(input, textarea, button, select, a) {
        -webkit-tap-highlight-color: rgba(0,0,0,0);
      }

      ${getParentSelector(scope)} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${getParentSelector(scope)} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      ${getParentSelector(scope)} [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${getParentSelector(scope)} select::-ms-expand {
        display: none;
      }

      ${getParentSelector(scope)} .noscroll {
        overflow-y: hidden;
      }

      ${getParentSelector(scope)} .scrollable {
        overflow-y: auto;
        overflow-x: hidden;
    
        &::-webkit-scrollbar {
          background-color: transparent;
          width: 8px;
        }
    
        &::-webkit-scrollbar-thumb {
          background-color: transparent;
          border-radius: 4px;
        }
      }

      ${getParentSelector(scope)} .scrollable:hover {
        &::-webkit-scrollbar-thumb {
          background-color: #cccccc;
        }
    
        &::-webkit-scrollbar-thumb:hover {
          background-color: #898989;
        }
      }

      ${getParentSelector(scope)} [data-rsbs-header] {
        padding: 0 !important;
      }

      ${getParentSelector(scope)} .chakra-tooltip__arrow-wrapper {
        --popper-arrow-offset: -6px !important;
      }

      ${getParentSelector(scope)} [data-popper-placement=bottom] {
        .chakra-tooltip__arrow {
          border-top-width: 1px !important;
          border-left-width: 1px !important;
        }
      }

      ${getParentSelector(scope)} [data-popper-placement=top] {
        .chakra-tooltip__arrow {
          border-bottom-width: 1px !important;
          border-right-width: 1px !important;
        }
      }

      ${getParentSelector(scope)} [data-popper-placement=right] {
        .chakra-tooltip__arrow {
          border-bottom-width: 1px !important;
          border-left-width: 1px !important;
        }
      }

      ${getParentSelector(scope)} [data-popper-placement=left] {
        .chakra-tooltip__arrow {
          border-top-width: 1px !important;
          border-right-width: 1px !important;
        }
      }

      ${getParentSelector(scope)} :is(input:-webkit-autofill, input:-webkit-autofill:focus) {
        transition: background-color 600000s 0s, color 600000s 0s;
      }

      ${getParentSelector(scope)} input[data-autocompleted] {
        background-color: transparent !important;
      }

      ${getParentSelector(scope)} .cb-dropdown input[type="text"] {
        height: auto;
      }
    ` }), system.isHostedExperience || disableCssTitleReset ? null : (_jsx(Global, { styles: css `
          ${getParentSelector(scope)} .cb-title-text[role='heading']:is(h1, h2, h3, h4, h5, h6) {
            color: var(--cb-title-text--color);
            font-family: var(--cb-title-text--font-family);
            font-weight: 600;
            text-transform: initial;
            margin: 0;
          }

          ${getParentSelector(scope)} {
            .cb-title-text[role='heading'] {
              &:is(h1) {
                font-size: var(--booking-engine-fontSizes-4xl);
              }

              &:is(h2) {
                font-size: var(--booking-engine-fontSizes-xl);
              }

              &:is(h3) {
                font-size: var(--booking-engine-fontSizes-lg);
              }

              &:is(h4) {
                font-size: var(--booking-engine-fontSizes-lg);
              }

              &:is(h5, h6) {
                font-size: var(--booking-engine-fontSizes-md);
              }
            }
            
            // Desktop specific styles

            @container page-content (width >= ${breakpoints.sm}) {
              .cb-title-text[role='heading'] {
                &:is(h2) {
                  font-size: var(--booking-engine-fontSizes-3xl);
                }

                &:is(h3) {
                  font-size: var(--booking-engine-fontSizes-xl);
                }
              }
            }
          }

          // For titles insisde HTML custom texts

          ${getParentSelector(scope)} [data-be-text].cb-text :is(h1, h2, h3, h4, h5, h6) {
            font-family: inherit;
            font-size: inherit;
            font-weight: 600;
            line-height: inherit;
          }
        ` }))] }));
